import { ColumnsLinkFormat, UserRole } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const getRoleLinkFormat = (role, linkFormat) => {
  if (role === UserRole.AREA_MANAGER) return ColumnsLinkFormat.NONE;
  return linkFormat;
};
